import { Meeting as ApiMeeting } from "../api/meetings";
import { Host, resolveHost } from "./host";
import {
  MeetingHostSchedule,
  fromApiHostSchedule,
} from "./meeting_host_schedule";

export interface InstanceMetadata {
  meetingType?: string;
  host?: Host;
  memberVisible: boolean;
  // Continuous room grouping key — see api/meetings.ts InstanceMetadata.
  continuousRoomKey?: string;
  /**
   * Partner scope as the calendar has it for this occurrence — its own, or
   * inherited from the series. The sync stamps the occurrence from it. Empty
   * string clears it.
   */
  partnerId?: string;
  /** Members see the calendar event's title instead of the meeting type's. */
  useCalendarTitle?: boolean;
}

export interface RecurringMetadata {
  meetingType?: string;
  memberVisible?: boolean;
  hostSchedule?: MeetingHostSchedule;
  continuousRoomKey?: string;
  /** Partner scope of the series master. Writing it also rewrites the
   * occurrences edited on their own, so it reaches every occurrence. */
  partnerId?: string;
  /** Same reach as partnerId when written. */
  useCalendarTitle?: boolean;
}

export const instanceFromApiMeeting = (
  apiMeeting: ApiMeeting,
  hostsById: Record<string, Host>,
): InstanceMetadata => {
  return {
    meetingType: apiMeeting.metadata.meetingType,
    host: apiMeeting.metadata.hostId
      ? resolveHost(apiMeeting.metadata.hostId, hostsById)
      : undefined,
    memberVisible: apiMeeting.metadata.memberVisible ?? false,
    continuousRoomKey: apiMeeting.metadata.continuousRoomKey,
    partnerId: apiMeeting.metadata.partnerId,
    useCalendarTitle: apiMeeting.metadata.useCalendarTitle ?? false,
  };
};

export const recurringFromApiMeeting = (
  apiMeeting: ApiMeeting,
  hostsById: Record<string, Host>,
): RecurringMetadata | undefined => {
  if (!apiMeeting.recurringMeeting) {
    return undefined;
  }
  const apiMetadata = apiMeeting.recurringMeeting.metadata;
  return {
    meetingType: apiMetadata.meetingType,
    hostSchedule: fromApiHostSchedule(apiMetadata.hostSchedule, hostsById),
    memberVisible: apiMetadata.memberVisible ?? false,
    continuousRoomKey: apiMetadata.continuousRoomKey,
    partnerId: apiMetadata.partnerId,
    useCalendarTitle: apiMetadata.useCalendarTitle ?? false,
  };
};
